<script>
/*  */
import ModalConfirm from '@/components/modal/ModalConfirm';
/*  */
import { mapState, mapActions } from 'vuex';
import Button from '@/components/Button';
import {} from '@/scripts/utils';
import User from '@/components/User';
import { applyLanguage } from '@/scripts/language';

export default {
  name: 'Profile',
  components: {
    Button,
    User,
    ModalConfirm,
  },
  props: {
    currentGameIsConnected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'balances', 'userData', 'tiers', 'showModalConfirm']),
    score() {
      const { balances, userData } = this;

      if (!balances || !userData) return null;

      const { nextTier = {}, currentTier = {} } = userData;
      const currentLevel = currentTier ? currentTier.level : 0;
      const nextLevel = nextTier ? nextTier.level : currentTier.level;
      const maxValue = parseFloat(
        nextTier ? nextTier.balanceRequired : currentTier.balanceRequired
      );
      const multiplier = currentTier ? parseFloat(currentTier.multiplier) : 1;
      const { RUSH = 0 } = balances || {};
      const currentValue = parseFloat(RUSH) || 0;

      const score = {
        maxValue,
        currentLevel,
        nextLevel,
        multiplier,
        /*  */
        currentValue,
      };

      score.widthLine = (score.currentValue * 100) / score.maxValue;

      return score;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      toggleModalBonusAction: 'toggleModalBonus',
      toggleModalConfirm: 'toggleModalConfirm',
    }),
    toggleModalBonus() {
      this.toggleModalBonusAction(true);
    },
    applyLanguage,
  },
};
</script>

<template>
  <div class="profile" v-cloak>
    <div class="profile__wrapper" v-if="user">
      <div class="profile__top">
        <!-- user -->
        <User
          :user="user"
          :score="score"
          :current-game-is-connected="currentGameIsConnected"
          class="user-profile"
        ></User>
        <!-- // -->
      </div>
      <div class="profile__middle">
        <div class="profile__row">
          <div class="profile__left">
            <div class="profile__title">
              {{ applyLanguage('bonusLevel') }}
            </div>
          </div>
          <div class="profile__right">
            <div class="profile__link" @click="toggleModalBonus">
              Learn More
            </div>
          </div>
        </div>
        <div class="profile__row">
          <div class="profile__left">
            <div v-if="score" class="profile__value">
              x{{ score.multiplier }}
            </div>
            <div class="profile__type">Level Multiplier</div>
          </div>
          <div class="profile__right">
            <div class="profile__subtitle">
              {{ applyLanguage('boostMultiplier') }}
            </div>
            <div class="profile__btn">
              <!-- to="wallet" -->
              <Button @click="toggleModalConfirm" class="boost">
                {{ applyLanguage('boost') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div class="profile__bottom">
        <div class="score" v-if="score">
          <div class="score__top">
            <div class="score__current">{{ score.currentValue }}</div>
            <span>/</span>
            <div class="score__max">{{ score.maxValue }} RUSH</div>
          </div>
          <div class="score__main">
            <div class="score__item">
              <div class="score__circle">{{ score.currentLevel }}</div>
              <div class="score__desc">lvl</div>
            </div>
            <div class="score__track">
              <div
                class="score__line"
                :style="{ width: score.widthLine + '%' }"
              ></div>
            </div>
            <div class="score__item score__item--next">
              <div class="score__circle">{{ score.nextLevel }}</div>
              <div class="score__desc">lvl</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- empty user -->
    <div class="profile__wrapper" v-else>
      <div class="profile__empty">
        <div class="empty">
          <div class="empty__title">Fusce vehicula dolor.</div>
          <div class="empty__text">
            Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In
            malesuada enim in dolor euismod.
          </div>
          <div class="empty__btn">
            <Button class="boost lg">
              Connect My Account
            </Button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal confirm -->
    <ModalConfirm
      v-if="showModalConfirm"
      @close="() => toggleModalConfirm()"
      @confirm="() => toggleModalConfirm()"
      color="positive"
      title="Coming soon!"
    />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.profile {
  width: 100%;
  max-width: 430px;
  display: flex;
  flex-direction: column;

  &__wrapper {
    width: 100%;
    border-radius: 24px;
    background-color: #232e33;
    flex-grow: 1;
  }

  &__top {
    padding: 20px 15px 15px;
  }

  &__middle {
    background-color: #202732;
    padding: 15px 15px 20px;
  }

  &__bottom {
    padding: 23px 15px 15px;
  }

  &__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & + & {
      margin-top: 20px;
    }
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #00c1fe;
  }

  &__link {
    text-align: right;
    text-decoration: underline;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffc800;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }

  &__value {
    font-family: Poppins-Light;
    font-size: 36px;
    letter-spacing: 0.75px;
    line-height: 51px;
    color: #ffc800;
    margin-top: -7px;
  }

  &__type {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    margin-top: 5px;
  }

  &__right {
    text-align: right;
    margin-left: 10px;
  }

  &__subtitle {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: #ffffff;
    margin-bottom: 15px;
  }

  &__btn {
    max-width: 176px;
    width: 100%;
    margin-left: auto;
  }

  &__empty {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
  }
}

.empty {
  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    color: #ffffff;
    margin: 15px;
    text-align: center;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
  }

  &__btn {
    margin-top: 60px;
    display: flex;
    justify-content: center;
  }
}

.score {
  &__top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  span {
    display: inline-block;
    font-family: Poppins-Regular;
    color: #ffd800;
    font-size: 16px;
    line-height: 30px;
    padding: 0 4px;
  }

  &__current {
    font-family: Poppins-Regular;
    font-size: 24px;
    line-height: 33px;
    color: #ffd800;
  }

  &__max {
    font-family: Poppins-Regular;
    font-size: 16px;
    line-height: 26px;
    color: rgba(255, 255, 255, 0.4);
    text-transform: uppercase;
  }

  &__main {
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 25px;
  }

  &__item {
    flex-shrink: 0;
    width: 32px;
    position: relative;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;

    &--next {
      width: 38px;
      .score__circle {
        width: 38px;
        height: 38px;
      }
    }
  }

  &__circle {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: Poppins-Bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.29px;
    color: #ffc800;
    background: #171430;
  }

  &__desc {
    font-family: Poppins-Bold;
    font-size: 10px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.21px;
    text-transform: uppercase;
    color: #ffce00;
    position: absolute;
    top: 100%;
    margin-top: 5px;
    width: 100%;
  }

  &__track {
    margin: 0 10px;
    flex-grow: 1;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      width: 100%;
      height: 4px;
      border-radius: 2px;
      background-color: #171e21;
    }
  }

  &__line {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 4px;
    border-radius: 2px;
    background-color: #ffce00;
    box-shadow: -1px 0px 8px 0px rgba(255, 206, 0, 0.75);
  }
}

@media (max-width: $mobile) {
  .profile {
    max-width: none;

    &__wrapper {
      border-radius: 0;
    }

    &__top {
      padding-bottom: 20px;
    }

    &__subtitle {
      font-size: 10px;
      line-height: 28px;
      margin-bottom: 5px;
    }

    &__btn {
      max-width: 120px;
    }

    &__bottom {
      padding-top: 35px;
    }
  }

  .score {
    &__top {
      margin-bottom: 13px;
    }
  }
}
</style>
